<script>
    import { formUrl } from '../store';
    import { selectedRadios, selectedChecks, selectedSwitches } from '../store'
    export let text;
    export let type;
    $: {
        const selectedSwitchesIds = Object.entries($selectedSwitches).map(([key, val]) => val.id);
        const selectedRadiosIds = Object.entries($selectedRadios).map(([key, val]) => val);
        const selectedRadiosChoice = Object.entries($selectedRadios).map(([key, val]) => key);
        const selectedChecksIds = Object.entries($selectedChecks).map(([key, val]) => {
            if(val.aantal > 1) {
                return val.id + ' ' + val.aantal + 'x';
            }
            return val.id
        });
        const url = new URL(window.location.origin + "/form-offerte");
        url.searchParams.set("kamers", selectedChecksIds.join(","))
        selectedRadiosChoice.forEach((radio, i) => {
            url.searchParams.set(radio, selectedRadiosIds[i])

        })
        if(selectedSwitchesIds.length > 0) {   
            url.searchParams.set("extra", selectedSwitchesIds.join(","))
        }
        // console.log(url.toString());

        updateUrl(url.toString())
    }
    
    function updateUrl(url) {
        formUrl.set(url)
    }
    
</script>

{#if type === 'submit'}
<input type="submit" form="mobox-form" value="{text}">
{:else}
<span class="toggle-button">{text}</span>
<!-- <input type="{type}" value="{text}"> -->
{/if}

<style>

    input, .toggle-button {
        appearance: unset;
        all: unset;
        font-size: 18px;
        font-weight: 700;
        background: #CA1E22;
        color: white;
        padding: 10px 25px;
        display: flex;
        width: 100%;
        position: relative;
        box-sizing: border-box;
        border-radius: 5px;
        margin-top: 15px;
        transition: all .3s ease;
    }

    input:hover {
        cursor: pointer;
        background-color: #b51619;
    }

    input::after {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21.594' height='19.501' viewBox='0 0 21.594 19.501'%3E%3Cg id='Group_16' data-name='Group 16' transform='translate(1 1.414)'%3E%3Cpath id='Path_40' data-name='Path 40' d='M2548.252,738.15l8.336,8.336-8.336,8.337' transform='translate(-2536.995 -738.15)' fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3E%3Cpath id='Path_41' data-name='Path 41' d='M2555.882,746.487h-18.888' transform='translate(-2536.995 -738.15)' fill='none' stroke='%23fff' stroke-linecap='round' stroke-width='2'/%3E%3C/g%3E%3C/svg%3E%0A");
    }


</style>